import { render } from "./CryptoPopup.vue?vue&type=template&id=520c7833&scoped=true"
import script from "./CryptoPopup.vue?vue&type=script&lang=js"
export * from "./CryptoPopup.vue?vue&type=script&lang=js"

import "./CryptoPopup.vue?vue&type=style&index=0&id=520c7833&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520c7833"]])

export default __exports__